import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// ---------------------------------------------------------------------------
// SEGURIDAD / PRIVACIDAD — anti "cache poisoning" cruzado entre usuarios
// ---------------------------------------------------------------------------
// Bug crítico corregido: un GET a una URL exacta (ej. /participant/diagnostic
// o /participant/diagnostic/report.pdf) es IDÉNTICA para todos los
// participantes. Si esa respuesta queda cacheada en cualquier punto de la
// red (caché del navegador, proxy/CDN institucional) — incluso si eso
// ocurrió ANTES de que el backend empezara a enviar "Cache-Control:
// no-store" — un usuario distinto podría recibir esa respuesta cacheada de
// OTRA persona, aunque el backend ya esté generando siempre datos frescos.
// Los headers de respuesta solo evitan que se guarden caches NUEVOS: no
// invalidan lo que ya estuviera cacheado desde antes en algún punto de la
// red. La defensa definitiva, independiente de cualquier caché intermedio,
// es asegurar que cada solicitud golpee una URL ÚNICA: agregamos un
// parámetro de "cache-busting" a TODO GET, de forma automática.
api.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _cb: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}` };
    config.headers = { ...(config.headers || {}), "Cache-Control": "no-cache" };
  }
  return config;
});

// Extrae un mensaje de error legible desde una respuesta de FastAPI (detail)
export function apiErrorMessage(err, fallback = "Ocurrió un error inesperado. Intenta nuevamente.") {
  if (err?.response?.data?.detail) return err.response.data.detail;
  if (err?.message === "Network Error") return "No hay conexión con el servidor. Verifica tu internet e intenta nuevamente.";
  return fallback;
}

export default api;
